// @flow
import type {Interests, UnmappedInterests} from "./type";

export const mapInterests: Array<Interests> = (datum: Array<UnmappedInterests>) => {
    if (!(datum && datum.length > 0)) return []
    return datum.map(d => ({
        id: d.id,
        description: {
            en: d.DescriptionEN.trim(),
            el: d.DescriptionEL.trim()
        },
        exhibitionIds: d.ExhibitionIds?.split(',')
    }))
}